import { ProductBatchDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { productBatchService, ProductBatchsFilters } from '@services/ProductBatchService'

const { reducer, actions, thunks } = baseCrudReducer<
  ProductBatchDto,
  {},
  {},
  ProductBatchsFilters
>('productBatch', productBatchService)

export default reducer

export const { setFilters: setProductBatchFilters } = actions

export const {
  getAll: getProductBatches
} = thunks
